import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { X, Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { fileUrl } from "@/lib/api";

export default function GalleryUpload({ value = [], onChange, testId = "gallery-upload", max = 6 }) {
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);

  const onFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const remaining = max - value.length;
    if (remaining <= 0) { toast.error(`Maksimum ${max} foto`); return; }
    setBusy(true);
    const uploaded = [];
    for (const file of files.slice(0, remaining)) {
      try {
        const form = new FormData();
        form.append("file", file);
        const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
        uploaded.push(data.path);
      } catch (err) {
        toast.error(err?.response?.data?.detail || `Gagal unggah ${file.name}`);
      }
    }
    if (uploaded.length) onChange([...value, ...uploaded]);
    setBusy(false);
    if (inputRef.current) inputRef.current.value = "";
  };

  const remove = (p) => onChange(value.filter((x) => x !== p));

  return (
    <div data-testid={testId}>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
        {value.map((p) => (
          <div key={p} className="relative aspect-square rounded-2xl overflow-hidden border border-bizma-border group">
            <img src={fileUrl(p)} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => remove(p)}
              className="absolute top-1 right-1 w-7 h-7 rounded-full bg-black/60 text-white grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity"
              data-testid={`gallery-remove-${p}`}>
              <X size={14} />
            </button>
          </div>
        ))}
        {value.length < max && (
          <button type="button" onClick={() => inputRef.current?.click()}
            className="aspect-square rounded-2xl border-2 border-dashed border-bizma-border bg-bizma-muted grid place-items-center text-bizma-subtext hover:bg-bizma-cream transition-colors"
            data-testid={`${testId}-add`}>
            {busy ? <Loader2 className="animate-spin" size={20} /> : <Upload size={20} />}
          </button>
        )}
      </div>
      <div className="mt-2 text-xs text-bizma-subtext">Hingga {max} foto galeri. Format JPG/PNG.</div>
      <input ref={inputRef} type="file" accept="image/*" multiple onChange={onFiles} className="hidden" data-testid={`${testId}-input`} />
    </div>
  );
}
